import { ITQProfileCompletionQuery } from '../types/tqConnectTypes';
import {
  ICreateTQShoutoutRequest,
  ITQProfileCompletionResponseRequest,
  ITQProfileCompletionResult,
  ITQProfileInfo,
  ITQProfileReviewsQuery,
  ITQProfileReviewsResult,
  ITQShoutout,
  ITQShoutoutsQuery,
  ITQShoutoutsResult,
} from '../types/tqConnectTypes/user';
import API from './';

export default class TQConnectUserAPI {
  static hostTQConnectUserProfileRoot = '/api/v1/tq-connect/profile';

  /**
   * Get TQ Connect profile info for user (code = 200)
   */
  static getTQConnectProfileInfo = (userId: string) => {
    return API.get<ITQProfileInfo>(
      `${this.hostTQConnectUserProfileRoot}/info`,
      {
        params: {
          queryForUser: userId,
        },
      },
    );
  };

  /**
   * Get profile completion queries (code = 200)
   */
  static getProfileCompletionQueries = () => {
    return API.get<{
      profileCompletionQueries: ITQProfileCompletionQuery[];
    }>(`${this.hostTQConnectUserProfileRoot}/queries`);
  };

  /**
   * Submit profile query response (code = 200)
   */
  static submitProfileQueryResponse = (
    data: ITQProfileCompletionResponseRequest,
  ) => {
    return API.post<ITQProfileCompletionResult>(`${this.hostTQConnectUserProfileRoot}/queries/response`, data);
  };

  /**
   * Get TQ Connect profile reviews (code = 200)
   */
  static getProfileReviews = (query: ITQProfileReviewsQuery) => {
    const { limit, page, rating, type, queryForUser } = query;

    const queryString = new URLSearchParams({
      ...(limit && { limit: String(limit) }),
      ...(page && { page: String(page) }),
      ...(rating && { rating }),
      ...(type && { type }),
      ...(queryForUser && { queryForUser }),
    }).toString();

    return API.get<ITQProfileReviewsResult>(`${this.hostTQConnectUserProfileRoot}/reviews${queryString ? `?${queryString}` : ''}`);
  };

  /**
   * Get TQ Connect profile shoutouts (code = 200)
   */
  static getProfileShoutouts = (query: ITQShoutoutsQuery) => {
    const { limit, page, visibility, type, queryForUser } = query;

    const queryString = new URLSearchParams({
      ...(limit && { limit: String(limit) }),
      ...(page && { page: String(page) }),
      ...(visibility && { visibility }),
      ...(type && { type }),
      ...(queryForUser && { queryForUser }),
    }).toString();

    return API.get<ITQShoutoutsResult>(`${this.hostTQConnectUserProfileRoot}/shoutouts${queryString ? `?${queryString}` : ''}`);
  };

  /**
   * Create TQ Connect profile shoutout (code = 200)
   */
  static createProfileShoutout = (data: ICreateTQShoutoutRequest) => {
    return API.post<ITQShoutout>(`${this.hostTQConnectUserProfileRoot}/shoutouts`, data);
  };
}
